'use client';

import { NavModal, NavToggle } from 'components/header/NavModal';
import Anchor from 'components/typography/anchor';
import { useState } from 'react';

export const Nav = () => {
  const [navIsOpen, setNavOpen] = useState(false);
  const openModal = () => {
    setNavOpen(true);
  };
  const closeModal = () => {
    setNavOpen(false);
  };

  return (
    <>
      <NavToggle onClick={openModal} />

      <nav
        className="flex h-16 items-center justify-center gap-3"
        aria-label="primary"
      >
        <Anchor className="hidden anchor-nav xs:inline" href="/chat">
          Chat
        </Anchor>
        <Anchor className="hidden anchor-nav xs:inline" href="/petitions">
          Petitions
        </Anchor>
        <Anchor className="hidden anchor-nav sm:inline" href="/premium">
          Join
        </Anchor>
        <Anchor className="hidden anchor-nav lg:inline" href="/letters">
          Letters
        </Anchor>
        <Anchor className="hidden anchor-nav lg:inline" href="/officials">
          Officials
        </Anchor>
        <Anchor className="hidden anchor-nav xs:inline" href="/guide">
          Guide
        </Anchor>
        <Anchor className="hidden anchor-nav sm:inline" href="/about">
          Help
        </Anchor>
      </nav>

      <NavModal navIsOpen={navIsOpen} closeModalFn={closeModal} />
    </>
  );
};

export default Nav;
